<template>
  <div
    v-if="notification.show"
    :class="`alert-${notification.type}`"
    class="alert alert-dismissible fade show">
    <span v-if="icon" class="fas fa-check-circle"></span>
    <span v-else class="fas fa-exclamation-triangle"></span>
      {{ notification.message }}
    <button type="button" class="close" @click="close()">
      <span>&times;</span>
    </button>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: 'notifications',
    data() {
      return {
        icon: false
      }
    },
    computed: {
      ...mapState(['notification']),
    },
    methods: {
      close() {
        const notification = {}
        this.$store.commit('setNotification', notification)
      },
      setTime() {
        setTimeout(() => { this.close() }, this.notification.timeout || 4000)
      }
    },
    watch: {
      notification: function (val) {
        if (val.type === 'success'){
          this.icon = true
        }
        if (val.show === true) {
          this.setTime()
        }
      }
    }
}
</script>

<style>
  .alert{
    top: 60px;
    right: 15px;
    z-index: 5000;
    max-width: 400px;
    padding: 20px 40px;
    position: fixed;
    border-radius: 4px;
    border-left: 8px solid;
    box-shadow: 2px 2px 2px #000000
  }

  .alert .fa-exclamation-circle{
    position: absolute;
    left: 20px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 15px;
  }

  .alert .fa-check-circle{
    position: absolute;
    left: 20px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 15px;
  }

  .alert .close{
    position: absolute;
    right: 0px;
    top: 50%;
    transform: translateY(-50%);
    padding: 20px 18px;
    cursor: pointer;
  }

  @keyframes show_alert {
    0%{
      transform: translateX(100%);
    }
    40%{
      transform: translateX(-10%);
    }
    80%{
      transform: translateX(0%);
    }
    100%{
      transform: translateX(-10%);
    }
  }

  .alert{
    animation: show_alert 1s ease forwards
  }
</style>
